import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { RedoReviewsRpcClientContext } from "./rpc-client";

export function useReviewsWorkspaceAccess() {
  const team = useRequiredContext(TeamContext);
  const nativeReviewsEnabled = team.settings.reviews?.enabled === true;
  const query = useRpcQuery(
    RedoReviewsRpcClientContext,
    "getReviewsWorkspaceAccess",
    null,
    { enabled: !nativeReviewsEnabled, staleTime: 60_000 },
  );

  return {
    workspaceAvailable:
      nativeReviewsEnabled || query.data?.workspaceAvailable === true,
    nativeReviewsEnabled,
    hasStoredReviews: query.data?.hasStoredReviews ?? false,
    connectedProviders: query.data?.connectedProviders ?? [],
    isPending: !nativeReviewsEnabled && query.isPending,
  };
}
